// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3zmPL","info":"PatientInfo_info__1YNu2"};